<template>
  <div>
    <Head title="Mitarbeiter/In bearbeiten" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold flex">
        <HeroIcon name="people" class="mr-2 h-10 w-10 fill-orfBlue-100" />
        <Link class="text-orfBlue-400 hover:text-orfBlue-600 mt-1" href="/users">MitarbeiterIn</Link>
        <span class="text-orfBlue-400 mx-2 font-medium mt-1">/</span>
        <template v-if="user.team">
          <div class="mt-1">{{user.department.name}}</div>
          <span class="text-orfBlue-400 mx-2 font-medium mt-1">/</span>
        </template>
        <div class=" mt-1">{{ form.first_name }} {{ form.last_name }}</div>
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <!--<trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>-->
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
<!--          <text-input v-model="form.username" :error="form.errors.username" class="pb-8 pr-6 w-full lg:w-1/2" label="Username" />-->
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
<!--          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />-->
          <select-input v-if="$page.props.is_admin" v-model="form.team_id" :pre="user.team ? user.team.id : null" :error="form.errors.team_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Team">
            <option :value="null">Kein Team</option>
            <option v-for="team in teams" :key="team.id" :value="team.id">{{team.name}}</option>
          </select-input>
          <select-input v-if="$page.props.is_dev" v-model="form.admin" :pre="form.admin ? form.admin : false" :error="form.errors.admin" class="pb-8 pr-6 w-full lg:w-1/2" label="Admin">
            <option :value="true">Ja</option>
            <option :value="false">Nein</option>
          </select-input>
        </div>
        <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button v-if="!user.deleted_at && $page.props.is_admin" :loading="form.processing" text="Mitarbeiter löschen" func="delete" inverted icon-name="save" icon-custom-icon @click.prevent="destroy"/>
          <button
              class="flex transition-colors 1s ease-in-out items-center mx-1.5 p-2 px-4 text-sm rounded border group bg-transparent hover:bg-orfBlue-100 text-orfBlue-100 border-orfBlue-100 hover:text-white"
              @click.prevent="passwordReset"
          >
            <HeroIcon name="key" class="w-4 mr-1"/>
            <div>Passwort zurücksetzen</div>
          </button>
          <loading-button :loading="form.processing" text="Aktualisieren" class="" icon-name="save" icon-custom-icon/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import HeroIcon from '@/Shared/HeroIcon.vue'
import {Inertia} from '@inertiajs/inertia'

export default {
  components: {
    HeroIcon,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    teams: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        username: this.user.username,
        email: this.user.email,
        password: '',
        admin: this.user.admin,
        photo: null,
        team_id: this.user.team ? this.teams.id : null,
      }),
    }
  },
  methods: {
    passwordReset() {
      if (confirm('Bist du dir sicher dass das Passwort zurücksetzen willst?')) {
        Inertia.put(`/users/${this.user.id}/resetPassword`)
      }
    },
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
